module.exports = __webpack_public_path__ + "static/img/run-success.ca41dfe4.png";